import { useLocation, useNavigate } from 'react-router-dom';
import { type AppRoutes } from '@sparrow-card/sparrow-card-constants';

const DEFAULT_SEARCH_PARAMS = [
  'SourceID',
  'AffliateID',
  'ProductID',
  'ExperienceID',
  'ExternalID',
  'PyrgilaudaDavidiana',
];

const getPreservedSearchParams = (
  locationSearch: string,
  newSearchParams?: Record<string, string>,
) => {
  const currentSearchParams = new URLSearchParams(locationSearch);
  const preservedSearchParams = new URLSearchParams();

  DEFAULT_SEARCH_PARAMS.forEach((param) => {
    const value = currentSearchParams.get(param);

    if (value) {
      preservedSearchParams.set(param, value);
    }
  });

  if (newSearchParams) {
    Object.entries(newSearchParams).forEach(([key, value]) => {
      preservedSearchParams.set(key, value);
    });
  }

  return preservedSearchParams.toString();
};

export const useNavigateWithPreservedParams = ({ replace: defaultReplace = false } = {}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (route: AppRoutes, newSearchParams?: Record<string, string>, replace = defaultReplace) => {
    const updatedSearchParams = getPreservedSearchParams(location.search, newSearchParams);

    navigate(`${route}?${updatedSearchParams}`, { replace });
  };
};
